<div class="standard-treeview-container">
    <div ngbDropdown container="body">
        <button type="button" class="btn btn-outline-primary btn-sm w-100 text-left treeview-dropdown-toggle" [ngClass]="{ empty: !selectedItemsToShow?.length }" ngbDropdownToggle>
            <label [for]="id" class="treeview-caption">{{ label }}</label>
            @for (item of selectedItemsToShow; track item) {
                <span class="chips">
                    <i class="fas fa-times chips-remove-icon" (click)="removeItem(item, $event)"></i> <span class="treeview-selected-item-label" [ngbTooltip]="treeviewItemTooltipTemplate">{{ item.text }}</span>
                </span>
                <ng-template #treeviewItemTooltipTemplate>
                    <ul class="mb-1 ps-4 fw-bold">
                        <li class="text-start">{{ item.tooltip.parentItemText }}</li>
                    </ul>
                    <div class="text-start ps-4">{{ item.tooltip.childItemText }}</div>
                </ng-template>
            }
            @if (selectedItemsToShow?.length && !singleSelection) {
                <i class="fas fa-times treeview-reset-icon" (click)="clearSelection($event)"></i>
            }
            @if (loading) {
                <span class="treeview-spinner-loader"></span>
            }
        </button>
        <div ngbDropdownMenu>
            @if (!loading) {
                <ngx-treeview [id]="id" [config]="config" [items]="items" [itemTemplate]="itemTemplate" (selectedChange)="onSelectionChange($event)"></ngx-treeview>
            }
        </div>
    </div>
    @if (hint?.length) {
        <small class="form-text text-muted d-block mt-1"><i class="far fa-hand-point-right"></i>{{ hint }}</small>
    }
    @if (ngControl?.invalid) {
        <div class="form-text text-danger">
            @if (ngControl?.errors?.required) {
                <div>
                    <i class="fas fa-exclamation-circle"></i>
                    @if (singleSelection) {
                        {{ 'dashboards.widgets.validation.singleAssetRequired' | translation: { name: label } | async }}
                    } @else {
                        {{ 'dashboards.widgets.validation.assetRequired' | translation: { name: label } | async }}
                    }
                </div>
            }
        </div>
    }

    @if (selectedItemsToShow?.length >= selectionLimit) {
        <div class="form-text text-info"><i class="fas fa-exclamation-circle"></i>{{ 'dashboards.widgets.validation.selectionLimit' | translation: { selectionLimit: $any(selectionLimit) } | async }}</div>
    }
</div>
